import { $api } from "../generated/client";

type UseGetShopExchangeOptionNamesParams = {
  shopId: string;
};

export default function useGetShopExchangeOptionNames({
  shopId,
}: UseGetShopExchangeOptionNamesParams) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/exchanges/option-names",
    {
      params: {
        path: { shopId },
      },
    },
    { enabled: !!shopId, staleTime: 1000 * 60 * 10 },
  );
}
